<div class="modal-header">
    <h5>ABM Posnet</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>
<div class="modal-body">
    <p>Points de aeroplanta: {{ aeroplantaSeleccionada?.nombre }}</p>
    <form [formGroup]="formPosnet">
        <div class="row col-md-12">
            <table class="table table-striped table-hover">
                <thead class="text-center">
                  <th>Alias</th>
                  <th>Nro Point</th>
                  <th>Activo</th>            
                </thead>
                <tbody class="text-center">
                  <tr *ngFor="let p of listPoints; let i=index" [ngClass]="{'modificado' : listPoints[i]?._modificado}">
                    <td>{{ p.alias }}</td>
                    <td>{{ p.nroPoint }}</td>
                    <td>                        
                        <div class="form-check form-switch" style="cursor: pointer;">
                            <input class="form-check-input" style="cursor: pointer;" [checked]="p.activo" type="checkbox" role="switch" id="{{listPoints[i].id}}" (change)="onCheck(i, $event.target.checked)">
                        </div>
                    </td>
                  </tr>
                  <tr>
                    <td>                        
                        <input type="text" class="form-control" formControlName="aliasFormControl" id="aliasFormControl" style="text-transform: uppercase;">
                        <div class="alert alert-danger"
                            *ngIf="aliasFormControl.invalid && aliasFormControl.errors.required && (aliasFormControl.dirty || aliasFormControl.touched)">
                            Requerido
                        </div>
                    </td>
                    <td>
                        <input type="number" class="form-control" formControlName="numeroFormControl" id="numeroFormControl">
                        <div class="alert alert-danger"
                            *ngIf="numeroFormControl.invalid && numeroFormControl.errors.required && (numeroFormControl.dirty || numeroFormControl.touched)">
                            Requerido
                        </div>
                    </td>
                    <td>
                        <button [disabled]="formPosnet.invalid" type="button" ngbTooltip="Agregar point" 
                            (click)="addPoint()" class="btn btn-success ms-2 px-1">
                            <i class="fa fa-plus"></i>
                        </button>
                    </td>
                  </tr>
                </tbody>
              </table>  
        </div>
    </form>
</div>
<div class="modal-footer bg-light justify-content-center">
    <button [disabled]="guardando" class="btn btn-primary me-2" id="aceptar" (click)="savePoint()">
        <span *ngIf="!guardando">Guardar</span>
        <div *ngIf="guardando" class="d-flex align-items-center">
            <div class="spinner-border text-light spinner-border-sm" role="status"></div>
            <span>Guardando...</span>
        </div>
    </button>
    <button type="button" class="btn btn-secondary" (click)="onClose()">Cancelar</button>
</div>